export default __webpack_public_path__ + "static/media/arrow_right.fb2986db.svg";